// eslint-disable react/prefer-stateless-function
import React, { createContext, useContext, useCallback, useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import RolePermAction from '../../store/actions/RolePermAction';
// Create the context
const RolesPermissionsContext = createContext();

// Custom hook to use the context
export const useRolesPermissions = () => {
  return useContext(RolesPermissionsContext);
};

// Provider component
function RolesPermissionsProvider({ children }) {
  const dispatch = useDispatch();
  const { userPermissions } = useSelector((state) => state.rolePermission); // Adjust this selector based on your Redux state structure
  const { loggedIn } = useSelector((state) => state.authentication);
  const [loading, setLoading] = useState(true);
  const initFetch = useCallback(() => {
    dispatch(RolePermAction.getUserPermissions()).finally(() => setLoading(false));
  }, [dispatch]);

  useEffect(() => {
    if (loggedIn) {
      initFetch();
    }
  }, [loggedIn, initFetch]); // Add isLoggedIn as a dependency

  const contextValue = useMemo(() => ({ ...userPermissions, loading }), [userPermissions, loading]);
  // If user is not logged in, return null
  // if (!loggedIn) {
  //  return null;
  // }

  return (
    <RolesPermissionsContext.Provider value={contextValue}>
      {children}
    </RolesPermissionsContext.Provider>
  );
}

// Define prop types
RolesPermissionsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default RolesPermissionsProvider;
